export const acceptImageType = 'image/*'
export const acceptPDFType = 'application/pdf'

export const mediaType = {
  image: 'image',
  pdf: 'pdf',
  video: 'video',
}
